import './DataAccessSearch.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createSonarSelector } from '@lib/selectors';
import { DataAccessSearchItems } from './DataAccessSearchItems';
import { SearchInput } from '@ui/general';
import { When } from 'react-if';
import { coreActions, SEARCH_LIMIT, TYPE_SEARCH_LIMIT } from '@sonar-software/sonar-core';
import React, { useCallback, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
export const dataAccessSearchDataSelector = createSonarSelector((state) => state.core.dataSecurity.dataAccess.search.get);
export const DataAccessSearch = () => {
    const [query, setQuery] = useState('');
    const [currentType, setCurrentType] = useState();
    const getSearch = useAction(coreActions.requestGetCoreDataSecurityDataAccessSearch);
    const resetSearch = useAction(coreActions.resetGetCoreDataSecurityDataAccessSearch);
    const searchData = useSonarSelector(dataAccessSearchDataSelector);
    const handleOnChange = useCallback((value) => {
        setQuery(value);
        if ((value === null || value === void 0 ? void 0 : value.length) >= 3) {
            getSearch({
                queryString: value,
                searchLimit: currentType ? TYPE_SEARCH_LIMIT : SEARCH_LIMIT,
                target: currentType
            });
            return;
        }
        if (!(value === null || value === void 0 ? void 0 : value.length) || (!currentType && searchData !== null)) {
            setCurrentType(undefined);
            resetSearch();
        }
    }, [currentType, getSearch, resetSearch, searchData]);
    const handleTypeChange = useCallback((type) => {
        setCurrentType(type);
        getSearch({
            queryString: query,
            searchLimit: type ? TYPE_SEARCH_LIMIT : SEARCH_LIMIT,
            target: type
        });
    }, [getSearch, query]);
    const showItems = currentType || query.length >= 3;
    return (React.createElement("div", { id: 'data-access-search-wrapper' },
        React.createElement("div", { id: 'data-access-search-box' },
            React.createElement(SearchInput, { autoFocus: true, className: 'data-access-search-input', id: 'data-access-search', onChange: handleOnChange, placeholder: COPY_SPECIFIC.SEARCH_FOR_DATA_ACCESS })),
        React.createElement(When, { condition: showItems },
            React.createElement(DataAccessSearchItems, { currentType: currentType, onTypeSelection: handleTypeChange }))));
};
